import { RouteConfig } from 'vue-router';

const Test = () => import(/* webpackChunkName: "Aiyy" */  './views/test.vue');


const routers: RouteConfig[] = [
    {
        path: 'test',
        component: Test
    },
    {
        path: '',
        redirect: 'test'
    },
];

export default routers;
